import { styled } from '@mui/material/styles'
import { useTranslate } from 'ra-core'
import React from 'react'
import { FormDataConsumer } from 'react-admin'
import { FormDataConsumerProps } from 'types/common'
import KAccordion from 'ui-shared/accordions/KAccordion'
import { WithSectionAndStatus } from 'ui-shared/CustomInputs/CustomReferenceInput'
import ClientAutocompleteArrayInput from './ClientAutocompleteArrayInput'
import OrganizationAutocompleteArrayInput from './OrganizationAutocompleteArrayInput'

const PREFIX = 'TailoredInput'

const classes = {
  redText: `${PREFIX}-redText`,
}

const StyledKAccordion = styled(KAccordion)({
  [`& .${classes.redText}`]: {
    color: '#FF0000',
  },
})

// this type is necessary because the professionals have only one section in our model
type WithCustomersAndOrganizations = {
  customers: number[]
  organizations: number[]
}
type Props = {
  validationMessage: string
  disableValidation?: boolean
  setFilter?: (customers: number[], organizations: number[]) => void
}

const TailoredInput: React.FC<Props> = ({
  validationMessage,
  disableValidation = false,
  setFilter,
}) => {
  const translate = useTranslate()
  return (
    <StyledKAccordion accordionTitle="Only For">
      <FormDataConsumer>
        {({
          formData,
        }: FormDataConsumerProps<
          WithCustomersAndOrganizations & WithSectionAndStatus
        >) => {
          const isInSection = !!formData.sections?.length
          return isInSection && !disableValidation ? (
            <u className={classes.redText}>{translate(validationMessage)}</u>
          ) : (
            <>
              {setFilter &&
                setFilter(formData.customers, formData.organizations)}
              <OrganizationAutocompleteArrayInput />
              <ClientAutocompleteArrayInput />
            </>
          )
        }}
      </FormDataConsumer>
    </StyledKAccordion>
  )
}

export default TailoredInput
